enum Routes {
  Landing = "/landing",
  SignIn = "/sign-in",
  SignUp = "/sign-up",
  CompleteRegistration = "/sign-up/complete-registration",
  ConfirmEmail = "/sign-up/confirm-email",
  EmailConfirmed = "/sign-up/email-confirmed",
  LinkExpired = "/sign-up/link-expired",
  NewPassword = "/new-password",
  PasswordRecovery = "/password-recovery",
  Terms = "/terms",
  PrivacyPolicy = "/privacy-policy",
  PrivacyPolicyNew = "/privacy-policy-new",
  TomList = "/tom-list",
  Scan = "/scan",
  Home = "/",
}

export { Routes };

enum RoutesDashboard {
  Home = "/dashboard",
  Capacity = "/capacity",
  Statistics = "/statistics",
  ArchivedOrders = "/archived-orders",
  UserManagement = "/user-management",
  OrdersExport = "/orders-export",
  WorkingHours = "/working-hours",
  PersonalDetails = "/dashboard/profile/personal-details",
  Preferences = "/dashboard/profile/preferences",
  Permissions = "/dashboard/profile/permissions",
}

export { RoutesDashboard };
// eslint-disable-next-line react-hooks/rules-of-hooks

export const LinksUrl = [
  {
    id: 1,
    title: "Home",
    url: RoutesDashboard.Home,
    isActive: false,
    beta: false,
  },
  {
    id: 2,
    title: "Working hours",
    url: RoutesDashboard.WorkingHours,
    isActive: false,
  },
  {
    id: 3,
    title: "Capacity",
    url: RoutesDashboard.Capacity,
    isActive: false,
    beta: false,
  },
  {
    id: 4,
    title: "Archived orders",
    url: RoutesDashboard.ArchivedOrders,
    isActive: false,
    beta: false,
  },
  {
    id: 5,
    title: "Statistics",
    url: RoutesDashboard.Statistics,
    isActive: false,
    beta: false,
  },
  {
    id: 6,
    title: "User management",
    url: RoutesDashboard.UserManagement,
    isActive: false,
    beta: false,
  },
  {
    id: 7,
    title: "Orders Export",
    url: RoutesDashboard.OrdersExport,
    isActive: false,
    beta: false,
  },
];
